import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid, Button, Select, MenuItem, InputLabel, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { BuscadorCambioTit } from "./BuscadorCambioTit";
import { AlertFinalizadoStepper } from "../stepper/AlertFinalizadoStepper";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { pasoFamiliarATitular, /* pasoTitularAFamiliar, */ updateGrupoFamiliar } from "../../actions/grupoFamiliarCambioTitularidad";
import { fetchParentescos } from "../../actions/cbos/parentescos";
import { PARENTESCOS } from "../../utils/constants";
import moment from "moment";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        width: 950,
        marginBottom: 20,
    },
    card: {
        width: 400,
        marginTop: 10,
        padding: 12,
    },
    button: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
    },
    formControl: {
        display: 'block',
        marginTop: 6,
    },
});

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle, id_parentesco) => ({
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    background: isDragging ? 'lightgreen' : (id_parentesco === 0 ? 'lightblue' : 'grey'),
    ...draggableStyle
});

const getListStyle = (isDraggingOver, droppableId) => ({
    background: isDraggingOver ? 'lightblue' : 'white',
    marginRight: droppableId && 'auto',
    padding: grid,
    width: 400,
});

function createData(idAfiliado, idGrupoFamiliar, ApellidoNombre, IdParentesco, id_sit_revista) {
    return { idAfiliado, idGrupoFamiliar, ApellidoNombre, IdParentesco, id_sit_revista };
}

export const HomeCambioTitularidad = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { itemsOrigen, itemsDestino } = useSelector((state) => state.grupoFamiliarCambioTitularidad);
    const { items: itemsParentesco } = useSelector((state) => state.parentescos);
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState([]);
    const [afiliadoSel, setAfiliadoSel] = useState({});
    const [mensaje, setMensaje] = useState('');
    const [open, setOpen] = useState(false);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [fechaVigencia, /* setFechaVigencia */] = useState(new Date());
    const [esPasoTitular, setEsPasoTitular] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [pathDestino, setPathDestino] = useState('');
    const [titularOrigen, setTitularOrigen] = useState();
    const [busquedaOrigen, setBusquedaOrigen] = useState('TITULARES');
    const [tieneCuilAsociado, setCuilAsociado] = useState(false);



    useEffect(() => {
        setItems(itemsOrigen);
        const temp = itemsOrigen.find(res => res.id_parentesco === 0);
        if (temp?.id_parentesco === 0) {
            setTitularOrigen(temp)
        }
    }, [itemsOrigen]);

    useEffect(() => {
        setSelected(itemsDestino);
    }, [itemsDestino]);

    useEffect(() => {
        dispatch(fetchParentescos());
    }, [dispatch]);

    const getList = id => id === 'droppable' ? items : selected;

    const onDragEnd = result => {
        const { source, destination } = result;

        // dropped outside the list
        if (!destination) {
            return;
        }

        if (source.droppableId !== 'droppable') {
            setOpen(true);
            setMensaje('Solo se puede mover de origen a destino');
            return;
        }

        if (source.droppableId === destination.droppableId) {
            const itemsR = reorder(
                getList(source.droppableId),
                source.index,
                destination.index
            );

            setItems(itemsR);

            if (source.droppableId === 'droppable2') {
                setSelected(itemsR);
            }
        } else {
            const afi = (getList(source.droppableId))[source.index];
            
            if (afi.id_parentesco === PARENTESCOS.CONCUBINA_O || afi.id_parentesco === PARENTESCOS.CONYUGE) {
                const familiar = itemsOrigen.find(cuilExistente => cuilExistente.cuil_familiaracargo);
                if (familiar?.cuil_familiaracargo === afi.cuil) {
                    setCuilAsociado(true);
                }
            }
            if (((itemsOrigen.length === 0 || itemsDestino.length === 0) && afi.id_parentesco !== 0)) {
                // if(afi.id_parentesco===0 && titularOrigen.fecha_baja){
                if (afi.id_afiliado === titularOrigen?.id_afiliado) {
                    setOpen(true);
                    setMensaje('No se puede volver a dar de alta como titular un afiliado que es titular, si se encuentra dado de baja se debe reactivar');
                } else if (moment().diff(moment(moment(afi.fecha_nacimiento).format('YYYY-MM-DD')), 'years', false) < 16) {
                    setOpen(true);
                    setMensaje('No se puede dar de alta como titular un afiliado con edad menor a 16 años');
                } else {
                    setAfiliadoSel(afi)
                    setOpenQuestion(true)
                    setEsPasoTitular(true)
                }
            } else {
                if (esValidoCambiarGrupoFamiliar((getList(source.droppableId))[source.index], getList(destination.droppableId))) {
                    const result = move(
                        getList(source.droppableId),
                        getList(destination.droppableId),
                        source,
                        destination
                    );

                    setItems(result.droppable);
                    setSelected(result.droppable2);
                }
            }

        }
    }

    const esValidoCambiarGrupoFamiliar = (afiliado, afiliadosGrupoDestino) => {
        if (afiliado.id_parentesco === 0) {
            setOpen(true);
            setMensaje('No se puede mover de Grupo Familiar al Titular sin previamenta haberle cambiado el parentesco');
            return false;
        }
        
        if ((afiliado.id_parentesco === PARENTESCOS.CONYUGE || afiliado.id_parentesco === PARENTESCOS.CONCUBINA_O)
        && afiliadosGrupoDestino.filter(s => s.id_parentesco === afiliado.id_parentesco && s.fecha_baja === null).length > 0) {
            setOpen(true);
            setMensaje('Los parentescos ESPOSO/A y CONCUBINA/O no se pueden repetir');
            return false;
        }
        return true;
    }

    const esValidoCambiarParentesco = (list, id_afiliado, validarGrupo, parentesco = null) => {
        // const itemToChange = list.find(s => s.id_afiliado === id_afiliado && s.id_parentesco === 0);
        // if(itemToChange && !(items.length===1 && items[0].id_parentesco===0) && !itemToChange?.fecha_baja){
        //     setOpen(true); 
        //     setMensaje('No se puede modificar el parentesco del Titular');
        //     return false;
        // }
        if (parentesco === 0) {
            setOpen(true);
            setMensaje('No se puede asignar como parentesco TITULAR a los afiliados. Se los debe pasar a un Grupo Familiar Destino vacio');
            return false;
        }
        if (validarGrupo) {
            const itemToChange = list.find(s => s.id_afiliado === id_afiliado && s.id_parentesco === 0);
            if (itemToChange.id_parentesco === 0) {
                setOpen(true);
                setMensaje('No se puede modificar el parentesco del Titular del Grupo Familiar Destino');
                return false;
            }
            if (list.find(s => s.id_afiliado === id_afiliado)?.idGrupoFamiliar === list.find(s => s.id_parentesco === 0).idGrupoFamiliar) {
                setOpen(true);
                setMensaje('Los parentescos del Grupo Familiar Destino no se pueden modificar salvo que sean afiliados provenientes del Grupo Familiar Origen');
                return false;
            }
        }
        return true;
    }

    const onChangeParentesco = (e, id_afiliado, droppableId) => {
        if (droppableId === 'droppable') {
            if (esValidoCambiarParentesco(items, id_afiliado, false, e.target.value)) {
                const tempItems = items.map(item => item.id_afiliado === id_afiliado
                    ? { ...item, id_parentesco: e.target.value }
                    : item
                );
                setItems(tempItems);
            }
        } else {
            if (esValidoCambiarParentesco(selected, id_afiliado, true, e.target.value)) {
                const tempSelected = selected.map(item => item.id_afiliado === id_afiliado
                    ? { ...item, id_parentesco: e.target.value }
                    : item
                );
                setSelected(tempSelected);
            }
        }
    }

    const handleClose = (event, reason) => {
        if (reason === "clickaway")
            return;
        setOpen(false);
    };

    const handleCloseAlert = () => {
        setEsPasoTitular(false);
        setOpenQuestion(false);
    };

    const handleCloseAviso = () => {
        setCuilAsociado(false);
        setOpenQuestion(true);
    };

    const handleSendPasoFamiliarATitular = () => {
        dispatch(pasoFamiliarATitular(afiliadoSel, fechaVigencia));
        setPathDestino('/afiliaciones/cambioTitular');
        setRedirect(true);
    };

    const handleSendPasoAfiliadoAOtroGrupo = () => {
        // let tituDestino = selected.filter(res=>res.id_parentesco===0)
        // let grupoFamiliarNuevo = selected.filter(res=>res.id_afiliado===titularOrigen.id_afiliado)
        const selectedRefactor = selected.map((s) => {
            return createData(
                s.id_afiliado,
                s.idGrupoFamiliar,
                s.apellido_y_nombre,
                s.id_parentesco,
                s.id_sit_revista,
            );
        });

        setPathDestino('/afiliaciones/cambioFamiliar');
        setRedirect(true);

        // if(items.length===0 && titularOrigen.id_parentesco===0){
        //         const titularAFamiliar = {
        //             idAfiliado:titularOrigen?.id_afiliado,
        //             IdGrupoFamiliarNuevo:tituDestino[0]?.idGrupoFamiliar,
        //             FechaVigencia:fechaVigencia,
        //             IdParentesco: grupoFamiliarNuevo[0]?.id_parentesco
        //         }
        //         dispatch(pasoTitularAFamiliar(titularAFamiliar, titularOrigen));
        // }else{
        dispatch(updateGrupoFamiliar(selectedRefactor, itemsDestino[0].idGrupoFamiliar, fechaVigencia, selected.find(s => s.id_parentesco === 0), titularOrigen?.id_afiliado));
        // }
    };

    const RealizarCambio = () => {
        if (itemsDestino.length > 0) {
            setOpenQuestion(true);
        } else {
            setOpen(true);
            setMensaje('Se debe cargar un Grupo Familiar de Destino para mover a familiares');
        }
    }

    const handleChangePorEspecialidad = (value) => {
        if (value)
            setBusquedaOrigen('TITULARES')
        else
            setBusquedaOrigen('FAMILIARES')
    }

    return (
        <div>
            <Grid className={classes.root}>
                <Grid container direction="row" justify="center" >
                    <Card className={classes.card} style={{ marginRight: 150 }}>
                        <BuscadorCambioTit title={'Grupo Familiar Origen'} droppableId={"droppable"} tipoBusqueda={busquedaOrigen} altabaja={'todos'} />
                        <FormControlLabel
                            style={{ float: 'right' }}
                            control={
                                <Checkbox
                                    name="busquedaOrigen"
                                    checked={busquedaOrigen === 'FAMILIARES'}
                                    onChange={() => handleChangePorEspecialidad(busquedaOrigen === 'FAMILIARES')}
                                />
                            }
                            label="Incluir Familiares"
                        />
                    </Card>
                    <Card className={classes.card}>
                        <BuscadorCambioTit title={'Grupo Familiar Destino'} droppableId={"droppable2"} tipoBusqueda={'TITULARES'} altabaja={'ALTA'} />
                    </Card>
                </Grid>
            </Grid>
            <Grid className={classes.root}>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable" >
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver, "droppable")}>
                                {items.map((item, index) => (
                                    <Draggable
                                        key={item.id_afiliado}
                                        draggableId={`${item.id_afiliado}`}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style,
                                                    item.id_parentesco
                                                )}>
                                                {item.apellido_y_nombre} - CUIL: {item.cuil}
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel id="select-parentesco-label">Parentesco</InputLabel>
                                                    <Select
                                                        style={{ marginTop: 13 }}
                                                        value={item.id_parentesco}
                                                        labelId="select-seccional-label"
                                                        name="id_parentesco"
                                                        onChange={(e) => { onChangeParentesco(e, item.id_afiliado, "droppable") }}
                                                        label="Parentesco"
                                                    >
                                                        {itemsParentesco.map((t) => (
                                                            <MenuItem key={t.idParentesco} value={t.idParentesco}>
                                                                {t.descripcionParentesco}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    <Droppable droppableId="droppable2">
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}>
                                {selected.map((item, index) => (
                                    <Draggable
                                        key={item.id_afiliado}
                                        draggableId={`${item.id_afiliado}`}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style,
                                                    item.id_parentesco
                                                )}>
                                                {item.apellido_y_nombre} - CUIL: {item.cuil}
                                                <FormControl className={classes.formControl}>
                                                    <InputLabel id="demo-mutiple-name-label">Parentesco</InputLabel>
                                                    <Select
                                                        style={{ marginTop: 13 }}
                                                        value={item.id_parentesco}
                                                        name="id_parentesco"
                                                        onChange={(e) => { onChangeParentesco(e, item.id_afiliado, "droppable2") }}
                                                        label="Parentesco"
                                                    >
                                                        {itemsParentesco.map((t) => (
                                                            <MenuItem key={t.idParentesco} value={t.idParentesco}>
                                                                {t.descripcionParentesco}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </Grid>
            <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={RealizarCambio}
            >
                Confirmar Cambios
            </Button>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    {mensaje}
                </Alert>
            </Snackbar>
            {openQuestion && (
                <AlertFinalizadoStepper
                    open={openQuestion}
                    pregunta={esPasoTitular ? "Alta de Nuevo Titular" : "Cambio de Grupo Familiar"}
                    dialogText={esPasoTitular ? "El grupo familiar de destino está vacío, desea dar de alta un nuevo Titular?" : "Quiere proceder con el cambio de Grupo Familiar?"}
                    buttonCancel={"Cancelar"}
                    buttonSubmit={"Continuar"}
                    // showDateDialog={true}
                    // fechaVigencia={fechaVigencia}
                    // setFechaVigencia={setFechaVigencia}
                    handleClose={handleCloseAlert}
                    handleSend={esPasoTitular ? handleSendPasoFamiliarATitular : handleSendPasoAfiliadoAOtroGrupo}
                />
            )}
            {tieneCuilAsociado && (
                <AlertFinalizadoStepper
                    open={tieneCuilAsociado}
                    pregunta={"Aviso"}
                    dialogText={"Existe un cuil asociado al afiliado que intenta pasar."}
                    buttonSubmit={"Continuar"}
                    handleSend={handleCloseAviso}
                />
            )}
            {redirect &&
                <Redirect
                    to={{
                        pathname: '/afiliaciones',
                        state: { from: pathDestino }
                    }}
                />
            }
        </div>
    );

};
